import React from "react";
import CountUp from "react-countup";
import Select from "react-select";
import VisibilitySensor from "react-visibility-sensor";
import propTypes from "prop-types";
const AlphaherdSectionContentCard = ({
  subTitle,
  title,
  titleDivider,
  description,
  description2,
  isButton,
  buttonText1,
  buttonHandler1,
  isClaimButton,
  buttonText2,
  buttonHandler2,
  isDropdown,
  dropdownOptions,
  dropdownhandler,
  isHorizontal,
  counter,
}) => {
  const customStyles = {
    option: (base, state) => ({
      ...base,
      background: "#fff",
      color: "#333",
      borderRadius: state.isFocused ? "0" : 0,
      "&:hover": {
        background: "#eee",
      },
    }),
    menu: (base) => ({
      ...base,
      borderRadius: 0,
      marginTop: 0,
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
    }),
    control: (base, state) => ({
      ...base,
      padding: 2,
      height: 60,
    }),
  };
  return (
    <>
      <div className="hero_content">
        <div className="title_wrapper">
          {subTitle && (
            <div
              className="subTitle"
              data-aos="fade-up"
              data-aos-delay="500"
              data-aos-duration="5000"
              data-aos-once="true"
              data-aos-easing="ease-in-out"
            >
              <p>{subTitle}</p>
            </div>
          )}
          {title && (
            <div
              className="title"
              data-aos="fade-up"
              data-aos-delay="700"
              data-aos-duration="5000"
              data-aos-once="true"
              data-aos-easing="ease-in-out"
            >
              <h2>{title}</h2>
              {titleDivider && <span className="divider"></span>}
            </div>
          )}
        </div>
        {description && (
          <div
            className="description"
            data-aos="fade-up"
            data-aos-delay="900"
            data-aos-duration="5000"
            data-aos-once="true"
            data-aos-easing="ease-in-out"
          >
            <p>{description}</p>
          </div>
        )}
        {description2 && (
          <>
            <div
              className="description"
              data-aos="fade-up"
              data-aos-delay="900"
              data-aos-duration="5000"
              data-aos-once="true"
              data-aos-easing="ease-in-out"
            >
              <p>{description2}</p>
            </div>
          </>
        )}
        {isButton && (
          <div className="button_text">
            {isClaimButton && (
              <>
                {buttonText1 &&
                  buttonText1.map((t, i) => (
                    <button
                      onClick={buttonHandler1}
                      className={`${i + 1 === 1 ? "mint" : "dropdown"}`}
                    >
                      {t}
                    </button>
                  ))}
                {isHorizontal && <h3 className="middle_text">Or</h3>}
              </>
            )}
            <div className="twice_button">
              {buttonText2 &&
                buttonText2.map((t, i) => (
                  <button
                    onClick={buttonHandler2}
                    className={`${i + 1 === 1 ? "mint" : "dropdown"}`}
                  >
                    {t.text} {t.icon}
                  </button>
                ))}
              {isDropdown && (
                <Select
                  styles={customStyles}
                  onChange={dropdownhandler}
                  options={dropdownOptions}
                />
              )}
            </div>
          </div>
        )}

        {counter && (
          <div className="counter_number">
            {counter.map((d, i) => (
              <div
                key={i + 1}
                className="counter_wrapper"
                data-aos="fade-up"
                data-aos-delay="800"
                data-aos-duration="5000"
                data-aos-once="true"
                data-aos-easing="ease-in-out"
              >
                <span className="count">
                  <CountUp
                    end={d.number}
                    start={0}
                    suffix={d.counterSuffix}
                    prefix={d.counterPrefix}
                    delay={1}
                  >
                    {({ countUpRef, start }) => (
                      <VisibilitySensor
                        partialVisibility={false}
                        onChange={start}
                      >
                        <span ref={countUpRef} />
                      </VisibilitySensor>
                    )}
                  </CountUp>
                </span>
                <div className="text">{d.text}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

AlphaherdSectionContentCard.propTypes = {
  subTitle: propTypes.string,
  title: propTypes.string,
  titleDivider: propTypes.bool,
  description: propTypes.string,
  description2: propTypes.string,
  isButton: propTypes.bool,
  buttonText1: propTypes.array,
  buttonHandler1: propTypes.func,
  isClaimButton: propTypes.bool,
  buttonText2: propTypes.arrayOf(
    propTypes.shape({
      text: propTypes.string.isRequired,
      icon: propTypes.element,
    })
  ),
  buttonHandler2: propTypes.func,
  isDropdown: propTypes.bool,
  dropdownOptions: propTypes.arrayOf(
    propTypes.shape({
      value: propTypes.string.isRequired,
      label: propTypes.string.isRequired,
    })
  ),
  dropdownhandler: propTypes.func,
  isHorizontal: propTypes.bool,
  counter: propTypes.arrayOf(
    propTypes.shape({
      number: propTypes.number.isRequired,
      text: propTypes.string,
      counterSuffix: propTypes.string,
      counterPrefix: propTypes.string,
    })
  ),
};

export default AlphaherdSectionContentCard;
